import React, { useState, useEffect } from "react";
import { MdDateRange, MdMonitorHeart } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { IoMdHeart } from "react-icons/io";
const ApprovedPage = () => {
  // State to manage selected event
  const [selectedEvent, setSelectedEvent] = useState("");
  const [events, setEvents] = useState([]);
  const [eventDetails, setEventDetails] = useState([]);
  const [favTrainers, setFavTrainers] = useState([]);
  const [selectedTrainers, setSelectedTrainers] = useState([]);
  useEffect(() => {
    fetchEvents();
  }, []);
  useEffect(() => {
    fetchTrainers();
  }, [selectedEvent]);
  const handleApprove = async (event_id, member_id) => {
    try {
      const response = await axios.get("/events/approve", {
        params: {
          event_id: event_id,
          member_id: member_id,
        },
      });
      if (response.data.success) {
        fetchTrainers();
        toast("Approved successfull!");
      }
      // setEvents(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  const fetchEvents = async () => {
    try {
      const response = await axios.get("/events/get_interested", {
        params: {
          user_type: sessionStorage.getItem("profession_id"),
          lom_id: sessionStorage.getItem("lom"),
        },
      });
      setEvents(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  const fetchTrainers = async () => {
    try {
      const response = await axios.get("/events/get_trainers", {
        params: {
          event_id: selectedEvent,
        },
      });
      console.log(response.data);
      setEventDetails(response.data.trainer_details);

      setFavTrainers(response.data.zone_trainer_id);
      setSelectedTrainers(response.data.selected_trainers);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };

  // Format event date to match dropdown selection format
  const formatEventDate = (date) =>
    new Date(date).toLocaleDateString("en-GB").replace(/\//g, "-");

  // Find the selected event's details

  return (
    <div className="p-4">
      <ToastContainer />
      {/* Header Section */}
      <div className="flex flex-col md:flex-row md:justify-between items-start md:items-center space-y-4 md:space-y-0">
        <h2 className="text-xl font-semibold md:mr-4">
          Please select an event
        </h2>
        <select
          value={selectedEvent}
          onChange={(e) => setSelectedEvent(e.target.value)}
          className="bg-white border rounded-lg p-4 text-base focus:outline-none focus:ring-2 focus:ring-blue-600 w-full md:w-auto md:flex-grow"
        >
          <option value="select event">Select Event</option>
          {/* The default option */}
          {events.map((event) => (
            <option key={event.event_id} value={event.event_id}>
              {`${event.event_name} - ${formatEventDate(event.event_date)}`}
            </option>
          ))}
        </select>
      </div>

      {/* <p className="mt-2 text-gray-700 dark:text-gray-300">
        These are the Zone Trainers that have interested but not confirmed yet.
      </p> */}

      {/* Event Details */}
      {eventDetails
        ? eventDetails.map((event) => (
            <div className="mt-16 md:mt-4">
              <div className="grid grid-cols-1 md:grid-cols-6 gap-4 p-2 border rounded-lg hover:bg-[#f8f8f8] mb-2">
                {/* Zone Trainer Name and Membership ID Section */}
                <div className="font-bold text-md mb-4 md:mb-0 text-center md:text-left">
                  <p className="text-[#93979a]">Zone Trainer Name:</p>
                  <p className="text-[#838383] flex items-center">
                    {" "}
                    {/* Add flex here to align items side by side */}
                    {event.name}
                    {favTrainers && favTrainers.includes(Number(event.id)) ? (
                      <i className="text-[#dd3434] text-lg ml-2">
                        {" "}
                        {/* Add ml-2 for some spacing between the name and icon */}
                        <IoMdHeart />
                      </i>
                    ) : null}
                  </p>
                </div>

                {/* Last Apply Date Section */}
                <div className="font-bold text-md mb-4 md:mb-0 text-center md:text-left">
                  <p className="text-[#93979a]">Membership ID:</p>
                  <p className="text-[#838383]">{event.id}</p>
                </div>

                {/* Button Section */}
                <div className="col-span-1 md:col-span-3 text-right mt-10 flex flex-col md:flex-row md:justify-end">
                  <button
                    onClick={() => handleApprove(event.event_id, event.id)}
                    className={`mb-2 md:mb-0 md:mr-2 ${
                      selectedTrainers &&
                      selectedTrainers.includes(String(event.id)) // Convert event.id to string
                        ? "bg-gray-400 text-gray-800 hover:bg-gray-300 cursor-not-allowed"
                        : "bg-blue-600 text-white hover:bg-gray-800"
                    } p-2 rounded-lg w-full md:w-auto`}
                  >
                    {selectedTrainers &&
                    selectedTrainers.includes(String(event.id)) // Convert event.id to string
                      ? "Approved"
                      : "Approve"}
                  </button>
                </div>
              </div>
            </div>
          ))
        : []}
    </div>
  );
};

export default ApprovedPage;
